import { SlidersHorizontal } from "lucide-react";

export default function ProductToolbar({ count, sort, setSort, onFilter }) {
  return (
    <div className="px-4 sm:px-5 md:px-10 pt-3 sm:pt-4 pb-2 flex flex-col lg:flex-row lg:items-end lg:justify-between gap-4">
      <div className="min-w-0">
        <p className="text-sm text-stone-500">
          Anasayfa <span className="mx-2 text-red-500">›</span> Bıçaklar
        </p>
        <h1 className="text-2xl sm:text-3xl font-extrabold mt-3 sm:mt-6 break-words">Bıçak Çeşitleri</h1>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:flex lg:items-center gap-3 w-full lg:w-auto min-w-0">
        <span className="text-red-600 text-sm sm:col-span-2 lg:col-span-1 lg:mr-2 whitespace-normal">{count} ürün listeleniyor</span>
        <button onClick={onFilter} className="min-w-0 border border-stone-900 bg-white px-4 sm:px-5 py-3 flex items-center justify-between gap-3 font-semibold">
          <span className="truncate">Ürünleri Filtrele</span>
          <SlidersHorizontal size={18} className="shrink-0" />
        </button>
        <select value={sort} onChange={(e) => setSort(e.target.value)} className="min-w-0 border border-stone-900 bg-white px-4 sm:px-5 py-3 outline-none">
          <option value="new">Varsayılan Sıralama</option>
          <option value="priceAsc">Fiyat artan</option>
          <option value="priceDesc">Fiyat azalan</option>
        </select>
      </div>
    </div>
  );
}
